import PropTypes from 'prop-types'
import React from 'react'

export const Item = ({name, price, options, onClick, isActive, duration, id, disabled, buttonText}) => (
  <div className='tip-oglasa-item'>
    <p className='tip-oglasa-naziv'>{name}</p>
    <p className='tip-oglasa-cena'>{price}&euro;</p>
    <ul className='tip-oglasa-lista'>
      {
        options.map((item, index) => <li key={index}>- {item}</li>)
      }
      {
        duration ? <li key='duration'>- Trajanje <span>{duration} dana</span></li> : null
      }
    </ul>
    <a
      className={`${isActive ? `active` : null}`}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      href='javascript:void (0)'
      data-id={id}
      onClick={disabled ? null : onClick}
    >{buttonText}</a>
  </div>
)

Item.propTypes = {
  id: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  duration: PropTypes.number,
  onClick: PropTypes.func,
  isActive: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired
}

Item.defaultProps = {
  desc: [],
  buttonText: 'Izaberi'
}
